@if (type() === "ordered") {
  <ol class="list">
    @for (item of items(); track $index) {
      <li>{{ item }}</li>
    }
  </ol>
} @else {
  <ul class="list">
    @for (item of items(); track $index) {
      <li>{{ item }}</li>
    }
  </ul>
}
